import { Button, TextField } from '@mui/material'
import React from 'react'
import { useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import BackdropProgress from '../components/BackdropProgress'
import { testMerge } from '../actions/testActions'

function MergeScreen() {

    const dispatch = useDispatch()

    const [templateText, setTemplateText] = useState('')
    const [reportText, setReportText] = useState('')

    const testMergeState = useSelector(state => state.testMergeReducer)
    const { loading, text } = testMergeState

    const handleMerge = () => {
        dispatch(testMerge(templateText, reportText))
    }

    return (
        <div>
            { loading && <BackdropProgress /> }

            <h6>Template Text</h6>
            <TextField multiline fullWidth rows={6} value={templateText} onChange={(e) => setTemplateText(e.target.value)}/>
            <br/>
            <br/>
            <h6>Report Text</h6>
            <TextField multiline fullWidth rows={6} value={reportText} onChange={(e) => setReportText(e.target.value)}/>
            <br/>
            <br/>
            <h6>Merged Text V1</h6>
            <TextField multiline fullWidth rows={6} value={text ? text.V1 : ''}/>
            <br/>
            <br/>
            <h6>Merged Text V2</h6>
            <TextField multiline fullWidth rows={6} value={text ? text.V2 : ''}/>
            <br/>
            <br/>
            <Button variant='contained' onClick={(e) => handleMerge()}>Submit</Button>
        </div>
    )
}

export default MergeScreen